import { Injectable } from '@angular/core';
import { AppUser } from '@classes/auth/infosUser';
import { NavLinks } from '@classes/navlinks/navlinks';
import { environment } from '@environments/environment';
import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  appName = new BehaviorSubject<string>(environment.appName);
  smartWasteViewChoice$ = new BehaviorSubject<string>('Tous');

  faSitemap = faSitemap;

  logoApp = new BehaviorSubject<object>(faSitemap);

  isAdmin = new BehaviorSubject<boolean>(false);
  isSuperAdmin = new BehaviorSubject<boolean>(false);
  navLinks = new BehaviorSubject<NavLinks[]>([]);
  userAppSelected = new BehaviorSubject<AppUser>(null);

  constructor() { }
}
